<template>
	<j-base-select
		:id="id"
		:options="options"
		:value="value"
		:placeholder="$t('select_insurer')"
		:allowSelectNothing="false"
		:status="status"
		:size="size"
		valueKey="id"
		nameKey="name"
		@input="onInput($event)"
	/>
</template>

<script>
/**
 * This component is smart. It's responsible for fetching insures
 * and siaplying them in select box
 * It's usually used somewhere in forms where insurer needs to be selected
 * @returns id of insurer
 */
import JBaseSelect from "@/components/JBaseSelect"
import api from "../api/"

export default {
	components: { JBaseSelect },
	props: {
		value: {
			validator(value) {
				return value === null || typeof value === "string"
			},
			required: true,
			default: null
		},
		id: {
			type: String,
			required: false
		},
		status: {
			type: String,
			required: false
		},
		size: {
			type: String,
			default: "medium"
		}
	},

	data: () => ({
		options: [],
		isLoading: false
	}),

	methods: {
		onInput(value) {
			this.$emit("input", value)
		},

		async getInsurers() {
			const tenantId = this.$store.state.tenantId

			this.isLoading = true
			let res = await api.insurers({ tenantId })
			this.isLoading = false

			if (!res.errors) this.options = res.data.insurers
		}
	},

	created() {
		this.getInsurers()
	}
}
</script>
